import styled from "@emotion/styled";
import { TruckModalWrapper } from "../TruckStyles.styles";

export const AddTruckOrderModalWrapper = styled(TruckModalWrapper)(({ theme }) => ({
	form: {
		"> div:last-of-type": {
			display: "flex",
			flexDirection: "column",
			gap: "16px",
			padding: "0 24px 24px 24px",
			"> span": {
				...theme.project.typography.body.body2
			},
			"> div:nth-of-type(2)": {
				display: "flex",
				flexDirection: "column",
				gap: "8px",
				"> span": {
					...theme.project.typography.subtitle.subtitle2
				},
				"> div": {
					display: "flex",
					gap: "24px",
					"> div": {
						display: "flex",
						flexDirection: "column",
						flex: 1,
						"span:first-of-type": {
							...theme.project.typography.subtitle.subtitle2
						},
						"span:last-of-type": {
							...theme.project.typography.body.body2
						}
					}
				}
			},
			"> div:last-of-type": {
				display: "flex",
				justifyContent: "space-between",
				gap: "16px",
				button: {
					flex: 1
				}
			}
		}
	}
}));
